module.exports = __webpack_public_path__ + "eda126632f1b5f1d3b5f1e7d00db38de.svg";